import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {FeedMatrixPack} from './FeedMatrixPack';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class FeedMatrix extends BasicEntity {
code: string;
description: TranslatedEmb;
label: TranslatedEmb;
lines: FeedMatrixPack[];
modulation: number | null;
weightGridCode: string;
}

